import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { func } from 'prop-types';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import OrderReview from '../../../common/OrderReview';

const OrderReviewContainer = ({ trackingCallback, orderReviewActionCallback, handleOrderReviewCallback }) => {
  const {
    showOrderReviewSection,
    orderReviewDescription,
    orderReviewActionText,
    orderReviewHandleableConfig,
    orderReviewModel,
  } = useSelector(state => state.propsData);
  const {
    entities: {
      orderInfo,
    },
  } = useSelector(state => state.mainStateData);
  const {
    isPaymentProcessingFeeModel: isPPF,
  } = useSelector(state => state.paymentOptions);
  if (isEmpty(orderInfo)) {
    return null;
  }
  return <OrderReview
    trackingCallback={trackingCallback}
    showOrderReviewSection={showOrderReviewSection}
    orderReviewDescription={orderReviewDescription}
    orderReviewActionCallback={orderReviewActionCallback}
    handleOrderReviewCallback={handleOrderReviewCallback}
    orderReviewActionText={orderReviewActionText}
    orderReviewHandleableConfig={orderReviewHandleableConfig}
    orderReviewModel={isPPF ? undefined : orderReviewModel}
    orderInfo={orderInfo}/>;
};

OrderReviewContainer.propTypes = {
  trackingCallback: func,
};

OrderReviewContainer.defaultProps = {
  trackingCallback: noop,
};

export default memo(OrderReviewContainer);
